module.exports = __webpack_public_path__ + "static/media/background.b3d4acd4.svg";